import { newEl, child, upTo, setClass, text } from "./dom.js";
import Grid from "./nice-grid.js";
import { initQuery } from "./util/query.js";
import ribbonColourer from "./colour-ribbons.js";
import loadPuzzle, { onStart, onWin } from "./common/daily.js";
import { openModal } from "./menu.js";
import { loadState, saveState } from "./game-state.js";
import "./colour-scheme.js";
import "./size.js";

if (!initQuery.data) loadPuzzle().then((puzzle) => {
	if (!puzzle) return;
	const { markers, exampleSolution } = puzzle;

	const w = exampleSolution[0].length / 2,
		h = exampleSolution.length / 2;
	const grid = new Grid(w, h);
	for (const b of markers)
		b.el = child(grid.cells[b.y][b.x].td, `div.bead.p${b.colour + 1}`);
	container.appendChild(grid.el);
	const colourRibbons = ribbonColourer();
	loadState(grid);
	onStart();

	let bestWalls = null;
	grid.onUpdate(() => {
		// work out which ribbon each bead is on
		for (const bead of markers) {
			bead.currentRibbon = grid.ribbons.findIndex(r => r.includesTile(bead.x, bead.y));
			if (bead.currentRibbon < 0) throw new Error("unexpected ribbon");
		}
		const ribbonsPerColour = {};
		for (const { colour, currentRibbon } of markers) {
			if (!ribbonsPerColour[colour]) ribbonsPerColour[colour] = new Set();
			ribbonsPerColour[colour].add(grid.ribbons[currentRibbon]);
		}

		colourRibbons(grid.ribbons, markers);

		let wallCount = 0;
		for (const { vWall, hWall } of grid.allCells()) {
			if (vWall) wallCount += 0.5;
			if (hWall) wallCount += 0.5;
		}
		document.getElementById("wall-count").innerText = wallCount;

		const complete = grid.ribbons.every(r => r.isComplete(markers).complete);
		if (complete && (!bestWalls || bestWalls > wallCount)) bestWalls = wallCount;
		const completeBest = complete && bestWalls == wallCount;
		
		document.getElementById("best").innerText = bestWalls;
		document.getElementById("knot-count").innerText = grid.ribbons.length;

		const submit = document.getElementById("submit");
		setClass(submit, "hidden", !complete && !bestWalls);
		setClass(submit, "submit-this", completeBest);
		setClass(submit, "submit-best", bestWalls && !completeBest);

		saveState(grid, wallCount, complete);
		if (complete) onWin();
	});

	grid.update(false);

	document.getElementById('reset').addEventListener("click", () => grid.removeAllWalls());
	document.getElementById('undo').addEventListener("click", () => grid.undo());
	document.getElementById('redo').addEventListener("click", () => grid.redo());

}).catch(() => alert("Unable to load puzzle"));

openModal("instructions");
